<template>
  <div>
    <JadeBox hasPadding>
      <div class="denied__img--container">
        <img :src="require(`@/assets/kyc/step_0.svg`).default" />
      </div>
      <div class="denied__text--container">
        <jade-text
          weight="bold"
          variant="heading-small"
        >
          {{ $t('title') }}
        </jade-text>
        <jade-text variant="text-medium">
          {{ $t('subtitle') }}
        </jade-text>
      </div>
    </JadeBox>
  </div>
</template>
<script>
import JadeBox from '@jade/JadeBox/index.vue'
import JadeText from '@jade/JadeText/index.vue'

export default {
  name: 'Denied',
  components: {
    JadeBox,
    JadeText
  },
  props: {
    merchantId: String
  }
}
</script>

<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.denied__img--container {
  display: flex;
  justify-content: center;
  padding-bottom: var(--global-space-300, 24px);
}
.denied__text--container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--global-space-200, 16px);
  padding-bottom: var(--global-space-300, 24px);
}
</style>

<i18n>
    {
      "pt-BR": {
        "title": "Não foi possível ativar sua conta",
        "subtitle": "Você pode tentar de novo em alguns meses."
      },
      "en-US": {
        "title": "We could not activate your account",
        "subtitle": "You can try again in a few months."
      }
    }
</i18n>
